import ActionSheet from "components/ActionSheet";
import Translation from "components/Translation";
import { useTenantContext } from "context/TenantContext";
import getConfig from "next/config";

interface LocationActionSheetProps {
    show: boolean,
    toggleShow(show: boolean): void
    selected_location_index: number
    setSelectedLocationIndex(index: number): void
}
export default function LocationActionSheet({
    show,
    toggleShow,
    selected_location_index,
    setSelectedLocationIndex
}: LocationActionSheetProps) {
    const { locations } = useTenantContext()
    const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

    return (
        <ActionSheet show={show} toggleShow={toggleShow}>
            <div className="flex flex-col pt-7 px-4 pb-5 w-full h-full">
                <Translation
                    content_key="calendar.locations_count"
                    content_values={{
                        loc_count: locations?.length || 0
                    }}
                    render_as="div"
                    className="font-medium text-sm text-gray-one"
                />
                <div className="flex flex-col mt-6 gap-y-5">
                    {locations?.map((location, index) => {
                        return (
                            <button
                                key={location.id}
                                className="flex flex-row w-full gap-x-3"
                                onClick={() => {
                                    setSelectedLocationIndex(index)
                                    toggleShow(false)
                                }}
                            >
                                <div
                                    className="rounded relative w-[60px] h-[50px]"
                                >
                                    <img
                                        src={location.image_url || `https://${NEXT_PUBLIC_STATIC_DOMAIN}/images/location/location_fallback.jpg`}
                                        className="w-full h-full"
                                    />
                                    {index == selected_location_index &&
                                        <div className="flex absolute bg-[#23476B80]/50 w-full h-full top-0 rounded">
                                            <i className="flex feather-check w-[18px] h-[18px] bg-white rounded-full justify-center align-middle text-secondary-blue m-auto text-sm" />
                                        </div>
                                    }
                                </div>
                                <div className="flex flex-col text-xs font-[450] text-left grow">
                                    <h3 className="font-medium text-sm">
                                        {location.name}
                                    </h3>
                                    <span>
                                        {location.street_1}
                                    </span>
                                    <span>
                                        {location.phone}
                                    </span>

                                </div>
                                <div
                                    hidden={index == selected_location_index}
                                    className="flex text-secondary-blue font-medium align-middle"
                                >
                                    <Translation
                                        content_key="calendar.select_location"
                                    />
                                </div>
                            </button>
                        )
                    })}
                </div>
            </div>
        </ActionSheet>
    )

}